export default "__VITE_ASSET__PuKSm9Jo__"